import { Box, Icon } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { LuLoader } from 'react-icons/lu';
import { FaCheck } from 'react-icons/fa6';
import { IoMdClose } from 'react-icons/io';

import { EAgentExecutionStatus } from '@/types/agents';

import { LogItemProps } from '../LogItem/LogItem';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const getIconAndColor = (status: LogItemProps['status']) => {
  switch (status) {
    case EAgentExecutionStatus.SUCCESS:
      return { icon: FaCheck, bgColor: 'gray.solid', borderColor: 'gray.100' };
    case EAgentExecutionStatus.FAILED:
      return { icon: IoMdClose, bgColor: 'red.muted', borderColor: 'red.solid', color: 'bg.default' };
    case EAgentExecutionStatus.IN_PROGRESS:
      return { icon: LuLoader, bgColor: 'grey.muted', borderColor: 'bg.default', color: 'bg.default' };
    default:
      return { icon: FaCheck, bgColor: 'gray.solid', borderColor: 'gray.100' };
  }
};

const StatusIcon = ({ status }: { status: LogItemProps['status'] }) => {

  const { icon: IconComponent, bgColor, borderColor, color } = getIconAndColor(status);

  return (
    <Box
      backgroundColor={bgColor}
      border="2px solid"
      borderColor={borderColor}
      minWidth={8}
      minHeight={8}
      display="flex"
      borderRadius="50%"
    >
      <Icon
        as={IconComponent}
        color={color && color || 'white'}
        m="auto"
        boxSize={3}
        animation={status === EAgentExecutionStatus.IN_PROGRESS ? `${spin} 1s linear infinite` : undefined}
      />
    </Box>
  );
};

export default StatusIcon;